/**
 * Constants for panel source selection and branch hierarchy
 * Shared across ModalCreateOrderContainer, BranchHierarchyTree, and related modules
 */

export const REGGORA_PANEL_ID = 'reggoraPanel'

export const PANEL_SOURCE = {
  BRANCH: 'branch',
  OUR_PANEL: 'ourPanel',
  PREFERRED: 'preferred',
  REGGORA_PANEL: 'reggoraPanel',
}

export const REGGORA_NETWORK_NAME = 'Reggora Network'

export const LENDER_PANEL_KEY_PREFIX = 'lender-panel-'
